/* tslint:disable */
/* eslint-disable */
/**
 * Intee
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserBearerTokenModel
 */
export interface UserBearerTokenModel {
    /**
     * 
     * @type {string}
     * @memberof UserBearerTokenModel
     */
    token: string;
}

export function UserBearerTokenModelFromJSON(json: any): UserBearerTokenModel {
    return UserBearerTokenModelFromJSONTyped(json, false);
}

export function UserBearerTokenModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserBearerTokenModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function UserBearerTokenModelToJSON(value?: UserBearerTokenModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

